import React from 'react';
import { useParams } from 'react-router-dom';
import AlertExecutionFragment from '@app/site/secured/alert-execution/fragment/AlertExecutionFragment';
import { useQuery } from '@tanstack/react-query';
import AlertService from '@app/model/alert/service/AlertService';
import { AlertExecutionQueryKeys } from '@app/model/alert/service/AlertQueryKeys';
import Message from '@app/component/message/Message';
import TablePlaceholder from '@app/component/placeholder/TablePlaceholder';

const AlertExecutionPage = React.memo(() => {
	const { alertExecutionId } = useParams();


	return !!alertExecutionId ? <Inside alertExecutionId={parseInt(alertExecutionId)} />: <Message state='error'>Alert execution could not be found!</Message>;
});

const Inside: React.FunctionComponent<{ alertExecutionId: number }> = ({ alertExecutionId }) => {
	const { data: alertExecution, isSuccess, isError } = useQuery({
		queryFn: () => AlertService.findAlertExecutionById(alertExecutionId),
		queryKey: AlertExecutionQueryKeys.detail(alertExecutionId),
	});

	if (isSuccess)
		return <AlertExecutionFragment alertExecution={alertExecution} isInDrawer />;
	else if (isError)
		return <Message state="warning">Alert execution could not be found</Message>;
	else return <TablePlaceholder />;
};

export default AlertExecutionPage;